"use client";

import { useState, useEffect } from "react";
import { formatTimeLeft } from "@/app/utils/time";

export default function useTimeLeft(end: number) {
  const [timeLeft, setTimeLeft] = useState<number>(0);

  useEffect(() => {
    setTimeLeft(0);
    if (!end) return;

    const now = new Date().getTime();
    let timeLeft = 0;
    if (now < end) {
      timeLeft = end - now;
    }
    setTimeLeft(timeLeft);

    const interval = setInterval(() => {
      const now = new Date().getTime();
      let timeLeft = 0;
      if (now < end) {
        timeLeft = end - now;
      }
      setTimeLeft(timeLeft);
    }, 1000);

    return () => clearInterval(interval);
  }, [end]);

  return formatTimeLeft(timeLeft);
}
